export interface SiteLink {
  action?: 'logIn' | 'logOut' | 'signUp'
  label: string
  url: string
  target?: string
  /** Render a plain <a> (full page load) — for routes served outside this app's client router. */
  external?: boolean
}

export interface SiteLinkGroup {
  id: string
  title?: string
  links: readonly SiteLink[]
}

export const brandLinkGroup: SiteLinkGroup = {
  id: 'brand',
  links: [
    { label: 'Home', url: '/' },
    { label: 'How It Works', url: '/how-it-works' },
    { label: 'How to Pack', url: '/pack' },
    { label: 'What Can I Ship?', url: '/what-can-i-ship' },
    { label: 'Our Guarantee', url: '/guarantee' },
    { label: 'Working with an Advisor?', url: '/travel' },
    { label: 'Ship to a Cruise', url: '/cruises' },
    { label: 'Reviews', url: '/reviews' },
    { label: 'Gift Cards', url: '/gift-cards' },
    { label: 'Shipment Tracking', url: '/track-orders' },
    { label: 'Ship', url: '/book/ship', external: true },
  ],
} as const

export const helpSupportLinkGroup: SiteLinkGroup = {
  id: 'help',
  title: 'Help & Support',
  links: [
    { label: 'FAQ', url: '/faq' },
    { label: 'Support', url: 'https://support.shipplay.com/', target: '_blank' },
    { label: 'Claims Center', url: '/claims' },
    { label: 'Drop-off Locator', url: '/drop-off-locator' },
    { label: 'Contact Us', url: '/contact' },
  ],
} as const

export const loggedOutAccountLinkGroup: SiteLinkGroup = {
  id: 'account',
  title: 'Account',
  links: [
    { action: 'logIn', label: 'Login', url: '#' },
    { action: 'signUp', label: 'Create Account', url: '#' },
  ],
} as const

export const accountMenuLinkGroup: SiteLinkGroup = {
  id: 'account-menu',
  title: 'Account',
  links: [
    { label: 'My Account', url: '/users/edit' },
    { label: 'Shipments', url: '/users/edit#view-orders' },
    { label: 'Address Book', url: '/users/edit#view-address-book' },
    { label: 'Gift Cards', url: '/gift-cards' },
    { label: 'Online Bill Pay', url: '/invoices/pay', target: '_blank' },
  ],
} as const

export const loggedInAccountLinkGroup: SiteLinkGroup = {
  id: 'account',
  title: 'Account',
  links: [...accountMenuLinkGroup.links, { action: 'logOut', label: 'Log Out', url: '#' }],
} as const

export const aboutUsLinkGroup: SiteLinkGroup = {
  id: 'about',
  title: 'About Us',
  links: [
    { label: 'About Us', url: '/about' },
    { label: 'Careers', url: '/careers' },
  ],
} as const

export const partnersLinkGroup: SiteLinkGroup = {
  id: 'partners',
  title: 'Our Partners',
  links: [
    { label: 'Partner with Us', url: '/partnership-benefits' },
    { label: 'Partnership Agreement & Terms', url: '/partner-agreement-terms' },
    { label: 'Become an Affiliate', url: '/affiliate' },
    { label: 'Travel Advisor Registration', url: '/advisor-signup' },
  ],
} as const

export const legalLinkGroup: SiteLinkGroup = {
  id: 'legal',
  title: 'Legal',
  links: [
    { label: 'Terms of Use', url: '/terms' },
    { label: 'Privacy Policy', url: '/privacy' },
  ],
} as const

export const brandFamilyLinkGroup: SiteLinkGroup = {
  id: 'brand-family',
  title: 'Our Brands',
  links: [
    { label: 'Ship&Play', url: 'https://www.shipplay.com' },
    { label: 'ShipSticks', url: 'https://www.shipsticks.com' },
    { label: 'ShipSkis', url: 'https://www.shipskis.com' },
    { label: 'ShipCamps', url: 'https://www.shipcamps.com' },
  ],
} as const

export const footerUtilityLinks: readonly SiteLink[] = [
  { label: 'Terms of Use', url: '/terms' },
  { label: 'Privacy Policy', url: '/privacy' },
  { label: 'Support', url: 'https://support.shipplay.com/', target: '_blank' },
  { label: 'Sitemap', url: '/sitemap' },
] as const
